export default function getRangeString(start, end, months, defaultLabel) {
  if (!start && !end) {
    return defaultLabel;
  }
  if (start.getTime() === end.getTime()) {
    return "".concat(months[start.getMonth()], " ").concat(start.getFullYear());
  }
  if (start.getMonth() === 0 && end.getMonth() === 11 && start.getFullYear() === end.getFullYear()) {
    return "".concat(start.getFullYear());
  }
  return "".concat(months[start.getMonth()], " ").concat(start.getFullYear(), " - ").concat(months[end.getMonth()], " ").concat(end.getFullYear());
}